export class StepSelector {
  public dataTourId: string;
  public selector: string;
  /**
   * Enter the "selector" as text when it will prefix with [data-tour="selector"]
   * @param selector
   */
  constructor(
    dataTourId: string,
    private prefix = "data-tour",
  ) {
    this.dataTourId = dataTourId;
    this.selector = `[${this.prefix}="${dataTourId}"]`;
  }
}
